import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import { createHandlerChainRunner, CustomHandler } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = CustomHandler<{ currentCountries: CountryModel[] }>;

export const DispatchSetCurrentCountries: CustomHandlerType = ({ dispatch, parameter: { currentCountries } }) => {
    dispatch({
        type: "Custom/SetCurrentCountries",
        currentCountries,
    });
};

export const chain = [DispatchSetCurrentCountries];

const setCurrentCountries = createHandlerChainRunner(chain, "SetCurrentCountries");
export default setCurrentCountries;
